// extracted by mini-css-extract-plugin
export default {"table":"MiscellaneousMenteeModulesTable_table__+6HDN"};